'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AVAILABLE = exports.AVAILABLE = 'AVAILABLE';
var AWAY = exports.AWAY = 'AWAY';
var BUSY = exports.BUSY = 'BUSY';
var INACTIVE = exports.INACTIVE = 'INACTIVE';
var OFFLINE = exports.OFFLINE = 'OFFLINE';
var UNKNOWN = exports.UNKNOWN = 'UNKNOWN';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/AgentStates.js
// module id = 204
// module chunks = 2 3